import { render } from "./ProfileSummary.vue?vue&type=template&id=27b16859&scoped=true"
import script from "./ProfileSummary.vue?vue&type=script&lang=js"
export * from "./ProfileSummary.vue?vue&type=script&lang=js"

import "./ProfileSummary.vue?vue&type=style&index=0&id=27b16859&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b16859"]])

export default __exports__